export default __webpack_public_path__ + "static/media/FS-Home-Formulario-Fondo-Verde.08107ac0.jpg";